import { useScreenId } from '@muse-web/router'
import { ScreenId } from '@core/router'

import type { THeaderVariant } from '../store/headerStore'

// Screens whose hero spans full-bleed behind the header render it transparent (light text, no fill).
const TRANSPARENT_SCREENS = new Set<ScreenId>([ScreenId.AUDIO, ScreenId.AUDIO_NOT_FOUND])
const BORDERLESS_SCREENS = new Set<ScreenId>([
    ScreenId.BROWSE,
    ScreenId.USER_AUDIO,
    ScreenId.USER_COLLECTIONS,
])

// Mirrored by backend-audio `AppShell::headerVariant()`.
export const useHeaderVariant = (): THeaderVariant => {
    const screenId = useScreenId<ScreenId>()

    return TRANSPARENT_SCREENS.has(screenId) ? 'transparent' : 'default'
}

export const useShowHeaderBorder = (): boolean => !BORDERLESS_SCREENS.has(useScreenId<ScreenId>())
